import { Skeleton, SkeletonItem, __css, tokens } from '@fluentui/react-components';

const useStyles = __css({"root":{"sshi5w":"f1qcbe8p","B7ck84d":"f1ewtqcl","mc9l5x":"f22iagw","Beiy3e4":"f1vx9l62","Belr9w4":"f13377fj","Dbcxam":0,"rjzwhg":0,"Bblux5w":"fg89v1a","Bnt446c":0,"B1hrpyx":0,"Fjva8n":"fnsi1rm","De3pzq":"f1dmdbja"},"hidden":{"qhf8xq":"f1euv43f","a9b677":"frkrog8","Bqenvij":"f1mpe4l3","B68tc82":0,"Bmxbyg5":0,"Bpg54ce":"f1a3p1vp","Bh84pgu":"f1w1vubc","Huce71":"fz5stix"},"bar":{"B2u0y6b":"f1ogbl2p"},"block":{"B2u0y6b":"f1fkkg1r"}});

/** Placeholder while the session loads. `label` is read by screen readers (live region). */
export function SessionSkeleton({ label }: { label: string }) {
  const styles = useStyles();
  return (
    <div className={styles.root} role="status" aria-busy="true">
      <span className={styles.hidden}>{label}</span>
      <Skeleton aria-hidden="true">
        <SkeletonItem className={styles.bar} size={28} />
        <SkeletonItem className={styles.block} size={120} />
        <SkeletonItem className={styles.block} size={72} />
      </Skeleton>
    </div>
  );
}


import "/opt/batiflow/app/apps/backoffice/src/shared/components/session-skeleton.griffel.css";